import styled from 'styled-components';
import { FlexiRow } from '../../../../styles/styled';
import Colors from '../../../../styles/colors';

export const CategoryBackdrop = styled.div`
  display: block;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const CategoryPopupContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  overflow: auto;
  position: fixed;
  padding: 10px 0px;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
`;

export const CategoryPopup = styled.div`
  display: block;
  position: relative;
  z-index: 10;
  width: 700px;
  max-width: 80%;
  min-height: 200px;
  background-color: #f9f9f9;
  border-radius: 5px;
  padding: 20px;
  .popTitle {
    font-size: 16px;
  }
  .field-title {
    font-size: 1.6rem;
    font-weight: 700;
    margin: 0 0 10px;
  }
  .field-input input {
    background-color: #fff;
    margin: 0;
    font-size: 1.6rem;
    border-radius: 5px;
  }
  .categorySelector {
    background-color: #ffffff;
    .selectorHead {
      padding: 8px;
      border-bottom: 1px solid #f0f0f0;
    }
    .selectorBody {
      padding: 8px;
      min-height: 310px;
    }
    .selectorRow {
      margin-bottom: 8px;
    }
  }
`;

export const CategoryRow = styled.div`
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  margin-left: 0;
  background-color: ${Colors.mainWhite};
  height: 86px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px 20px;
  position: relative;
  .categoryName {
    font-size: 18px;
    font-weight: bold;
    margin-right: auto;
    margin-left: 20px;
    i {
      font-size: 18px;
      position: relative;
      top: 3px;
    }
    .categoryNameEditWrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .categoryNameInput {
        width: 150px;
        max-width: 100%;
        input {
          margin-bottom: 0px;
        }
      }
      .categoryNameActions {
        margin-left: 5px;
      }
    }
  }
  .soundcastCount,
  .lastUpdated {
    margin-left: 20px;
    margin-right: 20px;
    font-size: 16px;
  }
  .editCategoryBtn {
    text-align: center;
    color: ${Colors.darkGrey};
    i {
      font-size: 2rem;
      position: relative;
      top: 2px;
    }
  }
  @media (max-width: 768px) {
    .editCategoryBtn {
      position: absolute;
      top: 8px;
      right: 1px;
    }
    .lastUpdated {
      margin-left: 50px;
    }
  }
  @media (max-width: 425px) {
    .soundcastCount {
      margin-left: 50px;
    }
  }
`;

export const CategoryDrag = styled.div`
  text-align: center;
  color: ${Colors.darkGrey};
  i {
    font-size: 3rem;
    position: relative;
    top: 3px;
  }
`;

export const CategoryPopupActions = styled.div`
  display: flex;
  .btn:first-child {
    margin-left: auto;
  }
  .btn {
    color: rgb(255, 255, 255);
    font-size: 16px;
    width: 160px;
    height: 40px;
    line-height: 40px;
    border-radius: 10px;
    margin-right: 10px;
    padding-top: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn.btn-orange {
    background-color: rgb(247, 107, 28);
  }
  .btn.btn-primary {
    background-color: rgb(97, 225, 251);
    color: rgb(0, 0, 0);
  }
`;

export const OrangeBadge = styled.span`
  line-height: 17px;
  display: inline-block;
  white-space: nowrap;
  border-radius: 0.35em;
  font-size: 1.1rem;
  font-weight: bold;
  padding: 1px 6px;
  color: #f76b1c;
  background-color: #fff;
  border: 1px solid #f76b1c;
  max-height: 21px;
  position: relative;
  top: -1px;
`;
